module.exports = __webpack_public_path__ + "img/1434642735.aa6754da.jpg";